<template>
  <div class="main-card">
    <div class="dc-items">
      <van-row  v-for="doctorInfo in doctorList" :key="doctorInfo.DOCTOR_ID" @click="appoint(doctorInfo)">
        <div class="dc-item">
          <van-col span="5">
            <div class="dc-image">
              <van-image round fit="fill" :src="'http://huyi-1252763274.cossh.myqcloud.com/' + doctorInfo.DOCTOR_IMG" />
            </div>
          </van-col>
          <van-col span="19">
            <van-col span="6" class="docName">{{ doctorInfo.DOCTOR_NAME }} </van-col>
            <div class="docTech"> {{ doctorInfo.TECHNICAL_NAME }}</div>
            <div class="docTech">{{ doctorInfo.DOMAIN }}</div>
            <div class="docDesc">{{ doctorInfo.INTRODUCTION }}</div>
          </van-col>
        </div>
      </van-row>
    </div>
  </div>
</template>

<script>
import {getQueryString, setLocal} from "@/common/js/utils";
import {customerBussiness, getWxUserInfo} from "@/service/MpServer";
import {Toast} from "vant";

export default {
  components: {
  },

  name: 'CusDocList',
  data() {
    return {
      isWinXinClient: false,
      isLoading: false,
      doctorList: []
    }
  },

  mounted() {
    const app = this;
    // 获取当用微信信息
    getWxUserInfo(function (){
      app.getDoctorList();
    });
  },

  methods: {
    appoint(docInfo){
      this.$router.push({path: '/CusDocDetail', query: {doctorId: docInfo.DOCTOR_ID}})
    },

    getDoctorList() {
      let _this= this;
      let param = {specDate:"1900-1-1"};
      customerBussiness("CUSTOMER", "getWDocList", param, function (data) {
        _this.doctorList= JSON.parse(data).Table;
        if (_this.doctorList.Length== 0)
          Toast("您还没有关注医生!");
      });
    }
  }
}
</script>

<style lang="less" scoped >
@import '../../common/style/mixin';

body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important;
  font-size: 14px !important;
}

.bt-type{
  margin: 10px 2px 0px 2px;
  height: 28px;
  line-height: 25px;
}

.sc-card{
  height: 40px;
  padding: 10px 0px 10px 0px;
  background: rgba(255,255,255,0.65);

  .sc-field{
    background: rgba(255,255,255,0);
  }
  .sc-key{
    border-radius: 20px;
  }
}

.main-card{
  //padding: 15px;
  height: 120px;
  background-image: linear-gradient(180deg, #01BD5D 0%, rgba(40,216,125,0.00) 100%);
}

.dc-items{
  top: 100px;
  margin-top: 10px;
  background: #FFFFFF;
}

.dc-item{
  margin-bottom: 6px;
  background: #FFFFFF;
  box-shadow: 0 8px 34px 0 rgba(0,0,0,0.08);
  padding: 5px;
  border-bottom: 2px solid #dedede;
  border-radius: 10px;
  border: 2px solid #dedede;
  height: 80px;

  .dc-image{
    margin: 5px 0px 0px 5px;
    width: 55px;
    height: 55px;
  }
  .docName{
    font-size: 18px;
    line-height: 24px;
    color: #333333;
  }
  .docTech{
    font-size: 15px;
    line-height: 26px;
    color: #999999;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .docDesc{
    line-height: 18px;
    font-size: 14px;
    font-weight: 40;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #999999;
  }
}
</style>
